###
  Campaigns widget
###

class INTENT.widgets.Advertiser

  @ATTR_NAME: "data-widget-advertiser"

  @ATTR_FIELD: "#{@ATTR_NAME}-field"

  constructor: (@el) ->
    @s = @.constructor

    @fields = @el.find "[#{@s.ATTR_FIELD}]"

    @field_create_site = @fields.filter "[#{@s.ATTR_FIELD}='create_site']"
    @field_create_segments = @fields.filter "[#{@s.ATTR_FIELD}='create_segments']"

    @update_creaters_states();

    @fields.on "click", =>
      @update_creaters_states();

    $('#is_postpaid').on 'change', =>
      @toggle_max_daily_budget();

  update_creaters_states: =>
    checked = @field_create_site.filter(':checked').val()

    unless checked
      @field_create_segments.attr('disabled', 'disabled')
    else
      @field_create_segments.removeAttr 'disabled'

  toggle_max_daily_budget: =>
    max_daily_budget = $('#max_daily_budget')
    enabled = $('#is_postpaid').is ':checked'
    max_daily_budget.attr 'disabled', !enabled
    form_group = max_daily_budget.parents '.form-group'
    if enabled then form_group.removeClass('hidden') else form_group.addClass('hidden');
